<script lang="ts">
import { AppLink } from '#components'

const mapping = {
  a: AppLink,
  script: 'pre',
  iframe: 'pre',
}

export default (props: any) => {
  return html2Vue(props.html, mapping)
}
</script>
